import { ICG2Guidelines } from '@fortem-monorepo/web-sdk'

export interface GuidelineTagsProps {
  guideline: ICG2Guidelines.Guideline
}

export const GuidelineTags: React.FC<GuidelineTagsProps> = ({ guideline }) => {
  return (
    <div className={'inline-flex items-center gap-2'}>
      <div
        className={'border border-gray-300 text-xs rounded-[4px] px-2 py-1 bg-gray-50 font-mono'}
      >
        <span className={'text-gray-500'}>table: </span>
        <span className={'text-gray-600'}>{guideline.table}</span>
      </div>
      <div
        className={'border border-gray-300 text-xs rounded-[4px] px-2 py-1 bg-gray-50 font-mono'}
      >
        <span className={'text-gray-500'}>column: </span>
        <span className={'text-gray-600'}>{guideline.value_column}</span>
      </div>
      <div
        className={'border border-gray-300 text-xs rounded-[4px] px-2 py-1 bg-gray-50 font-mono'}
      >
        <span className={'text-gray-500'}>type: </span>
        <span className={'text-gray-600'}>{guideline.threshold_type}</span>
      </div>
      {Object.entries(guideline.identifiers ?? {}).map(([key, value]) => {
        return (
          <div
            className={
              'border border-blue-300 text-xs rounded-[4px] px-2 py-1 bg-blue-50 font-mono'
            }
          >
            <span className={'text-blue-500'}>{key}: </span>
            <span className={'text-blue-600'}>{value as string}</span>
          </div>
        )
      })}
    </div>
  )
}
